
import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/layouts/Icon.vue';
import EnvRepository from '@/repository/EnvRepository';

@Component({
  components: {
    Icon,
  },
})
export default class Erro01View extends Vue {
  get getTopUrl(): string {
    return EnvRepository.getEnv().VUE_APP_BENEFIT_BENEFITSTATION_URL;
  }

  get errorMessage(): string {
    return EnvRepository.getEnv().VUE_APP_UNMATCH_ORDERSITE_ERROR;
  }
}
